﻿export type ParkingCategory = string & { readonly __brand: unique symbol };
export const DefaultParkingCategory: ParkingCategory = "::default::" as ParkingCategory;
